import React from 'react';
import { css } from '@emotion/react';
import t from 'react-translate';

import { config } from '@config/pendo.config.json';
import { black, white } from 'styles/global_defaults/colors';
import {
  halfSpacing,
  largeSpacing,
  standardSpacing,
  tripleSpacing,
} from 'styles/global_defaults/scaffolding';

const ICON_CIRCLE_SIZE = 60;

type Props = {
  message: string;
};

const styles = css`
  flex: 1;
  gap: ${standardSpacing}px;
  padding: ${largeSpacing}px ${tripleSpacing}px;
  color: ${black};

  .error-icon-circle {
    width: ${ICON_CIRCLE_SIZE}px;
    height: ${ICON_CIRCLE_SIZE}px;
    border-radius: 50%;
    background: ${white};
  }

  .error-icon {
    font-size: 30px;
    line-height: 1;
  }

  .error-text {
    gap: ${halfSpacing}px;
  }
`;

const ErrorState: React.FC<Props> = ({ message }) => (
  <div
    css={styles}
    className='d-flex flex-column align-items-center justify-content-center text-center'
    data-qa={config.pendo.submissionView.aiInsights.errorState}
  >
    <div className='error-icon-circle d-flex align-items-center justify-content-center'>
      <span className='error-icon' role='img' aria-hidden='true'>⚠️</span>
    </div>
    <div className='error-text d-flex flex-column align-items-center'>
      <h2 className='text-xl font-weight-light m-0'>
        {t.SUBMISSIONS.AI_ASSIGNMENT.UNAVAILABLE_STATE.TITLE()}
      </h2>
      <p className='text-medium m-0'>{message}</p>
    </div>
  </div>
);

export default ErrorState;
